import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import products from '../Assets/Datas/products';
import productss from '../Assets/Images/slider4.jpeg';

const ProductDetail = () => {
  const { id } = useParams();
  const product = products.find((p) => p.id === parseInt(id));
  const [selectedImage, setSelectedImage] = useState(product.images[0]);

  const handleDoubleClick = () => {
    window.open(selectedImage, '_blank');
  };

  return (
    <div className="p-4">
      <div className="relative h-36 md:h-72 w-full mb-8">
        <div
          className="h-full w-full rounded-lg shadow-lg"
          style={{
            backgroundImage: `url(${productss})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="absolute px-2 inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center">
            <h1 className="text-2xl md:text-4xl font-semibold text-white uppercase tracking-wider">
              {product.name}
            </h1>
          </div>
        </div>
      </div>
     
      <div className="grid grid-cols-1 md:grid-cols-2 md:items-center gap-4">
          <div>
          <div className="flex justify-center mb-6">
          <img
            src={selectedImage}
            alt={product.name}
            className="h-96 object-contain rounded-lg shadow-md cursor-pointer hover:shadow-lg transition duration-300"
            onDoubleClick={handleDoubleClick}
          />
        </div>
        <div className="flex justify-center space-x-4 mb-6">
          {product.images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`${product.name} ${index + 1}`}
              className={`w-12 h-24 object-contain rounded-md cursor-pointer transition-transform duration-300 transform hover:scale-105 ${selectedImage === image ? 'ring-4 ring-blue-500' : 'ring-2 ring-transparent'}`}
              onClick={() => setSelectedImage(image)}
              onDoubleClick={handleDoubleClick}
            />
          ))}
        </div>
          </div>
          <p className="text-gray-600 md:mt-5 text-lg leading-relaxed">{product.longDesc}</p>
      </div>
      
    </div>
  );
};

export default ProductDetail;
